// extracted by mini-css-extract-plugin
export default {"button":"DetailsButton_button__qDIyH"};